export default "__VITE_ASSET__D1UdO9PX__"